import { render, staticRenderFns } from "./intologisticsrecord-list.vue?vue&type=template&id=65002d04"
import script from "./intologisticsrecord-list.vue?vue&type=script&lang=ts"
export * from "./intologisticsrecord-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports